var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 3,
    transform: "translate(0 -0.474)",
    fill: "#197ff5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1.347,4.827,2.931l-2.851.416a.625.625,0,0,0-.345,1.066l2.063,2.01L3.206,9.261a.624.624,0,0,0,.906.658L6.662,8.578,9.212,9.919a.625.625,0,0,0,.906-.658L9.63,6.422l2.063-2.01a.625.625,0,0,0-.345-1.066L8.5,2.931,7.222.347a.625.625,0,0,0-1.12,0Z",
    transform: "translate(3.838 5.504)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumPlan);
export default __webpack_public_path__ + "static/media/premium_plan.19327d28963e3012593fde231c090d28.svg";
export { ForwardRef as ReactComponent };